import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import {
  checkRequired,
  validateEmail,
  validatePhoneNumber,
} from "pages/formTools";
import { Vendor } from "..";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

type SignatoryFields = Pick<
  Vendor,
  | "signatoryFirstName"
  | "signatoryLastName"
  | "signatoryPosition"
  | "signatoryEmail"
  | "signatoryPhone"
>;

// All five are required once the primary contact can't sign.
export const validateSignatory = (data: SignatoryFields): FieldErrorMap => ({
  signatoryFirstName: checkRequired(
    ta("fields.signatory_first"),
    data.signatoryFirstName ?? "",
  ),

  signatoryLastName: checkRequired(
    ta("fields.signatory_last"),
    data.signatoryLastName ?? "",
  ),

  signatoryPosition: checkRequired(
    ta("fields.signatory_position"),
    data.signatoryPosition ?? "",
  ),

  signatoryEmail: validateEmail({
    name: ta("fields.signatory_email"),
    value: data.signatoryEmail ?? "",
    required: true,
  }),

  signatoryPhone: validatePhoneNumber({
    name: ta("fields.signatory_phone"),
    value: data.signatoryPhone ?? "",
    required: true,
  }),
});
